var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 5.5,
    stroke: "#B58027"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0582 13.0076C21.2551 12.4808 20.6759 11.6377 20.4949 10.6553C20.456 10.4431 20.4343 10.2245 20.4343 10.001H17.8715L17.8674 20.3358C17.8244 21.4932 16.8776 22.4222 15.7173 22.4222C15.3565 22.4222 15.017 22.3315 14.7179 22.1731C14.0321 21.81 13.5628 21.0868 13.5628 20.2546C13.5628 19.0592 14.5294 18.0866 15.717 18.0866C15.9387 18.0866 16.1515 18.1235 16.3526 18.1867V15.5541C16.1444 15.5255 15.9327 15.5078 15.717 15.5078C13.116 15.5078 11 17.637 11 20.2546C11 21.8604 11.7972 23.2815 13.0139 24.1409C13.7801 24.6823 14.7123 25.001 15.7173 25.001C18.3183 25.001 20.4343 22.8718 20.4343 20.2546V15.0138C21.4394 15.7396 22.6711 16.1674 24 16.1674V13.5885C23.2843 13.5885 22.6176 13.3744 22.0582 13.0076Z",
    fill: "#B58027"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.b973a10b2a11c048a9c7032ee2b10f1c.svg";
export { ForwardRef as ReactComponent };